module.exports = __webpack_public_path__ + "img/yffx.1a93b1aa.png";